<template>
    <div class="main-con el-main">
        <nav-breadcrumb :menu="[{label: '助贷资方清算表'}]"/>
        <el-form :model="reportForm"  ref="reportForm" label-width="150px">
            <el-row :gutter="10" class="bg-purple xamhtrpg">
                <el-col :span="12">
                    <el-form-item label="资方：" prop="l__lenderId" :rules="{required: true, message: '资方不能为空'}">
                        <el-select placeholder="请选择资方" v-model.trim="reportForm.l__lenderId" filterable>
                            <el-option :label="item.label" :value="item.value" v-for="(item,idx) in lenderOptions" :key="idx"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="应还款月：" prop="plan__repayDate" :rules="{required: true, message: '应还款月不能为空'}">
                        <el-date-picker
                            v-model="reportForm.plan__repayDate"
                            value-format="yyyy-MM-01 00:00:00"
                            type="month"
                            placeholder="选择日期">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="tr xzmt">
            <el-button type="primary" @click="onSubmit('reportForm')">导出</el-button>
        </div>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import moment from 'moment'
    import Status2CN from "../../filters/Status2CN";
    import {xmlBuildQuery} from "../../filters/CommonActions";
    import {formatMoney} from "../../filters/CommonFilters";
    export default {
        name: "LenderRebateList",
        data() {
            return {
                reportForm:{
                    l__lenderId:'',
                    plan__repayDate:'',
                    taxFactor:0
                },
                lenderOptions:[],
                dialogVisible:false,
                transactionStatus: this.$route.query['fi.transactionStatus'],

                listData: {},


            }
        },
        computed : {
            filterParams: {
                get: function() {
                    return {
                        /*  pageSize: this.pageSize,
                          pageOffset: (this.page - 1) * this.pageSize,*/
                        // 'xlist.sort.dataField': 'fi.transactionDate',
                        // 'xlist.sort.order': 'desc'
                    }
                },
                set:function (newVal) {

                }
            }
        },
        watch: {
            filterParams: function () {
                this.getReportingFinanceList()
            }
        },
        mounted() {
            // this.getReportingFinanceList()
            this.getLenderList()
        },
        methods: {

            getLenderList: function () {
                xhr.getLenderList(
                    Object.assign({pageSize:0}, this.filterParams, {}),
                    res=> {
                        try {
                            this.lenderOptions = res.data.data.map(item=>{
                                return {
                                    label: item.d__lenderName,
                                    value:item.d__lenderId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            onSubmit:function (formName) {
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        let routeData = this.$router.resolve({
                            path: '/ix/fang/financing/lender/reporting/LenderRebate.List?format=xls',
                            query: Object.assign({}, this.filterParams, {
                                'xlist.search.plan.repayDate':this.reportForm.plan__repayDate,
                                'xlist.search.plan.repayDate.op':'gteq',
                                'lenderId':this.reportForm.l__lenderId,
                            })
                        });
                        window.open(routeData.href.replace('#/', '/'), '_blank');

                    }
                })
            },
            onClose:function () {
                this.dialogVisible = false
                this.reportForm.taxFactor = 0
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/LenderRebateList.vue